import { CloseOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { Alert } from '@/components/molecules/Alert';

import styles from './ToastMessage.module.css';

import type { ToastProps } from './types';

export default function ToastMessage({
  description,
  duration = 3000,
  id,
  isVisible,
  onClose,
  position = 'topRight',
  title,
  type = 'info',
}: ToastProps) {
  const [toastIsVisible, setToastIsVisible] = useState(() => false);

  useEffect(() => {
    if (!isVisible) return;

    const timer = setTimeout(() => {
      setToastIsVisible(true);
      setTimeout(() => onClose(), 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [id, onClose, duration, isVisible]);

  if (!isVisible && !toastIsVisible) return null;

  const toastContent = (
    <div
      className={clsx(styles.toastContainer, styles[position], toastIsVisible ? styles.toastExit : styles.toastEnter)}
    >
      <Alert type={type} showIcon paddingSize="md" alignIcon="top">
        <div className={styles.content}>
          <span className={styles.title}>{title}</span>
          {description && <span>{description}</span>}
          <button
            className={styles.closeButton}
            onClick={() => {
              setToastIsVisible(true);
              setTimeout(() => onClose(), 300);
            }}
          >
            <CloseOutlined />
          </button>
        </div>
      </Alert>
    </div>
  );

  return createPortal(toastContent, document.body);
}
